import { useEffect, useRef } from 'react'
import { reportLog } from 'services/userMonitoring'

function useWarnMissingCurrency(
  shouldWarn: boolean,
  event: string,
  context: Record<string, unknown>,
) {
  const hasWarnedRef = useRef(false)
  useEffect(() => {
    if (shouldWarn && !hasWarnedRef.current) {
      hasWarnedRef.current = true
      reportLog(event, context, 'warn')
    }
  }, [shouldWarn, event, context])
}

export default useWarnMissingCurrency
